module.exports = __webpack_public_path__ + "static/spread.afbfb124.png";


//////////////////
// WEBPACK FOOTER
// /Users/grantmaclennan/code/_archive/Toos/src/images/spread.png
// module id = 180
// module chunks = 0